<template lang="pug">
    .home

        .title
            h1.title__title(v-html='title')

            router-link.title__next(to='/chapterone')
                svg(xmlns='http://www.w3.org/2000/svg', width='138.21' height='112.75' viewBox='0 0 138.21 112.75')
                    use(xlink:href='#arrow-right')

            .credits
                .credits__item(
                    v-for='(creditValue, creditKey) in credits',
                    :key='creditKey'
                    )
                    h3.credits__title(v-html='creditValue.title')
                    p.credits__body
                        span(
                            v-for='(creditItem, creditIndex) in creditValue.items',
                            :key='creditIndex',
                            v-html='creditItem'
                            )

        Keyhole.home__keyhole(
            video='v1',
            :muted='true',
            clip='big',
            keyhole='big',
            stroke='orange',
            :touchable='false'
            )

        a.home__lenta(href='https://lenta.ru', target='_blank', rel='noopener')
            svg(xmlns='http://www.w3.org/2000/svg', width='90', height='15', viewBox='0 0 90.15 14.97')
                use(xlink:href='#lenta')

</template>

<script>
const Keyhole = () => import('@/components/Keyhole.vue');

export default {
    name: 'Home',

    components: {
        Keyhole
    },

    data() {
        return {
            title: 'Пиратская россия',
            credits: {
                authors: {
                    title: 'Авторы',
                    items: ['Анастасия Евтушенко', 'Михаил Карпов']
                },
                help: {
                    title: 'Благодарим за помощь',
                    items: ['Group-IB и онлайн-кинотеатр okko']
                }
            }
        };
    }
};
</script>

<style lang="scss">
@import '~poly-fluid-sizing';
@import '../assets/css/vars.scss';

@keyframes pulse-right {
    0% {
        transform: translateX(0);
    }
    20% {
        transform: translateX(10px);
    }
    40% {
        transform: translateX(0);
    }
}

.home {
    overflow: hidden;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    margin: 0;
    background: url('../assets/img/home.jpg') no-repeat 50% 50% / cover;

    @supports (--css: variables) {
        height: calc(var(--vh, 1vh) * 100);
    }

    &::before {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.6);
    }

    &__keyhole {
        --video-width: 1229px;
        --video-height: 480px;
        --keyhole-width: 275px;
        --keyhole-height: 480px;

        position: absolute;
        top: 18vh;
        right: calc((var(--width-grid-column) + var(--width-grid-gap) + var(--width-grid-right)) - ((var(--video-width) - var(--keyhole-width)) / 2));
        width: var(--video-width);
        height: var(--video-height);

        $mapVideoWidth: (
            320px: 512px,
            768px: 871px,
            1920px: 1229px
        );
        @include poly-fluid-sizing('--video-width', $mapVideoWidth);

        $mapVideoHeight: (
            320px: 200px,
            768px: 340px,
            1920px: 480px
        );
        @include poly-fluid-sizing('--video-height', $mapVideoHeight);
        @include poly-fluid-sizing('--keyhole-height', $mapVideoHeight);

        $mapKeyholeWidth: (
            320px: 115px,
            768px: 195px,
            1920px: 275px
        );
        @include poly-fluid-sizing('--keyhole-width', $mapKeyholeWidth);

        @media (--viewport-tablet) {
            right: calc((var(--width-grid-column-mobile) + var(--width-grid-gap-mobile)) - ((var(--video-width) - var(--keyhole-width)) / 2));
        }

        video {
            width: 100%;
        }
    }

    &__lenta {
        position: absolute;
        top: 3vh;
        right: var(--width-grid-right);
        display: flex;
        align-items: center;
        width: 90px;
        height: 15px;
        margin: 0;
        color: var(--color-main-text);

        @media (--viewport-tablet) {
            top: auto;
            bottom: 3vh;
            right: var(--width-grid-gap-mobile);
        }

        $mapWidth: (
            320px: 50px,
            1920px: 90px
        );
        @include poly-fluid-sizing('width', $mapWidth);

        $mapHeight: (
            320px: 8px,
            1920px: 15px
        );
        @include poly-fluid-sizing('height', $mapHeight);

        svg {
            width: 100%;
            height: 100%;
            vertical-align: 0;
            fill: currentColor;
        }
    }
}

.title {
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    width: calc((var(--width-grid-column) * 6) + (var(--width-grid-gap) * 6));
    margin: 0;

    @media (--viewport-tablet) {
        width: calc((var(--width-grid-column-mobile) * 6) + (var(--width-grid-gap-mobile) * 5));
    }

    &__title {
        text-transform: uppercase;
        font-family: var(--font-title);
        font-weight: var(--font-title-weight);
        font-style: var(--font-title-style);
        line-height: 1;
        font-size: 130px;

        $mapFontSize: (
            320px: 45px,
            768px: 110px,
            769px: 55px,
            1920px: 130px
        );
        @include poly-fluid-sizing('font-size', $mapFontSize);
    }

    &__next {
        position: absolute;
        bottom: 0;
        right: 0;
        animation: pulse-right 1.5s infinite;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 138px;
        height: 113px;
        margin: 0;
        color: var(--color-accent-1);

        $mapWidth: (
            320px: 60px,
            768px: 100px,
            769px: 61px,
            1920px: 138px
        );
        @include poly-fluid-sizing('width', $mapWidth);

        $mapHeight: (
            320px: 49px,
            768px: 82px,
            769px: 50px,
            1920px: 113px
        );
        @include poly-fluid-sizing('height', $mapHeight);

        @media (--viewport-tablet) {
            align-self: flex-end;
        }

        svg {
            width: 100%;
            height: 100%;
            vertical-align: 0;
            stroke: currentColor;
            stroke-width: 2px;
        }
    }
}

.credits {
    position: absolute;
    top: 100%;
    left: calc((var(--width-grid-column) * 5) + (var(--width-grid-gap) * 5));
    display: flex;
    flex-direction: column;
    width: calc((var(--width-grid-column) * 3) + (var(--width-grid-gap) * 3));
    margin-top: 6vh;
    font-family: var(--font-accent);
    font-weight: var(--font-accent-weight);
    font-style: var(--font-accent-style);
    line-height: 1.12;
    font-size: 18px;

    $mapFontSize: (
        320px: 10px,
        768px: 16px,
        769px: 12px,
        1920px: 18px
    );
    @include poly-fluid-sizing('font-size', $mapFontSize);

    @media (--viewport-laptop) {
        left: 0;
        width: calc((var(--width-grid-column) * 7) + (var(--width-grid-gap) * 7));
        flex-direction: row;
        justify-content: space-between;
    }

    @media (--viewport-tablet) {
        right: 0;
        width: 100%;
    }

    &__item {
        margin: 0;

        @media (--viewport-laptop) {
            width: 50%;
        }

        @media (--viewport-tablet) {
            width: calc((var(--width-grid-column-mobile) * 3) + (var(--width-grid-gap-mobile) * 2));
        }

        &:not(:last-child) {
            margin-bottom: 1em;
        }
    }

    &__title {
        margin: 0 0 0.1em;
        color: var(--color-accent-1);
    }

    &__body {
        display: flex;
        flex-direction: column;
        margin: 0;
    }
}
</style>
